<script>
import { useMainStore, useEventStore } from '../../../stores/index';
import moment from 'moment';
import { AxiosAPI } from '@/axios';
export default {
  name: 'ChatMensagem',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  setup () {
    const StoreAll = useMainStore();
    const event = useEventStore();
    return {
      Store: StoreAll,
      event
    };
  },
  data () {
    return {
      chatnowDataUser: [],
      mensagens: [],
      ToSendUser: [],
      mensagemToSend: '',
      uuid: '',
      newchat: false,
      userScrolled: false,
      currentPage: 1,
      loading: false,
      sending: false,
      allMessagesLoaded: false
    };
  },
  updated () {
    if (!this.userScrolled) {
      this.scrollToBottom();
    }
  },
  mounted () {
    if (this.user.title !== undefined) {
      this.uuid = this.user.uuid;
      this.user.users.forEach(DataUser => {
        if (DataUser.uuid !== this.Store.user.uuid) {
          this.ToSendUser = DataUser;
        }
      });
      this.getMensagens();
      this.newchat = this.user.newchat;
    }
    if (this.user.title === undefined) {
      this.uuid = this.user.uuid;
      this.ToSendUser = this.user;
      this.newchat = this.user.newchat;
    }

    window.Echo.channel('chat.' + this.uuid).listen('.App\\Events\\MessageEvent', (data) => {
      const msg = this.mensagens;
      msg.push(data.message);
      this.mensagens = msg;
    });

    const container = this.$refs.chatContainer;

    this.handleScroll = () => {
      const threshold = 100;
      const position = container.scrollTop + container.offsetHeight;
      const height = container.scrollHeight;

      if (position >= height - threshold) {
        this.userScrolled = false;
      } else {
        this.userScrolled = true;
      }
    };

    container.addEventListener('scroll', this.handleScroll);

    const chatContainer = this.$refs.chatContainer;

    chatContainer.addEventListener('scroll', () => {
      if (chatContainer.scrollTop === 0) {
        this.getMensagens();
      }
    });
  },

  beforeUnmount () {
    const container = this.$refs.chatContainer;
    if (this.handleScroll) {
      container.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    SendMensagem () {
      if (this.sending || !this.mensagemToSend.trim()) return;
      this.sending = true;
      if (this.newchat) {
        AxiosAPI.post('/api/chats',
          {
            users: [this.user.uuid],
            type: 'private'
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + this.Store.accessToken
            }
          })
          .then((response) => {
            AxiosAPI.post('/api/chats/send-message',
              {
                chat_uuid: response.data.chat.uuid,
                content: this.mensagemToSend
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + this.Store.accessToken
                }
              })
              .then((response) => {
                this.getMensagensNewChat(response.data.message.chat_uuid);
                this.mensagemToSend = '';
                this.Store.ChatGet();
                this.adjustTextareaHeights();
                window.Echo.channel('chat.' + response.data.message.chat_uuid).listen('.App\\Events\\MessageEvent', (data) => {
                  const msg = this.mensagens;
                  msg.push(data.message);
                  this.mensagens = msg;
                });
                this.newchat = false;
                this.uuid = response.data.message.chat_uuid;
                this.sending = false;
              })
              .catch((error) => {
                console.log(error);
                this.sending = false;
              });
          })
          .catch((error) => {
            console.log(error);
            this.sending = false;
          });
      }
      if (!this.newchat) {
        AxiosAPI.post('/api/chats/send-message',
          {
            chat_uuid: this.uuid,
            content: this.mensagemToSend
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + this.Store.accessToken
            }
          })
          .then((response) => {
            const msg = this.mensagens;
            msg.push({
              ...response.data.message,
              user: { uuid: this.Store.user.uuid, name: this.Store.user.name }
            });
            this.mensagens = msg;
            this.mensagemToSend = '';
            this.Store.ChatGet();
            this.adjustTextareaHeights();
            this.sending = false;
          })
          .catch((error) => {
            console.log(error);
            this.sending = false;
          });
      }
    },

    getMensagens () {
      if (this.loading || this.currentPage > this.messages_last_page) return;

      const container = this.$refs.chatContainer;
      const oldScrollHeight = container.scrollHeight;
      const oldScrollTop = container.scrollTop;
      this.loading = true;

      AxiosAPI.get(
    `/api/chats/messages?per_page=10&page=${this.currentPage}&chat_uuid=${this.uuid}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.Store.accessToken
      }
    }
      )
        .then((response) => {
          const novasMensagens = response.data.chats.messages.reverse();
          this.mensagens = [...novasMensagens, ...this.mensagens];

          this.currentPage++;
          this.messages_last_page = response.data.chats.messages_last_page;

          this.$nextTick(() => {
            const newScrollHeight = container.scrollHeight;
            container.scrollTop = newScrollHeight - oldScrollHeight + oldScrollTop;
          });

          return AxiosAPI.post(
            '/api/chats/read-notifications',
            { chat_uuid: this.uuid },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.Store.accessToken
              }
            }
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getMensagensNewChat (value) {
      AxiosAPI.get('/api/chats/messages?chat_uuid=' + value, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.Store.accessToken
        }
      })
        .then((response) => {
          this.mensagens = response.data.chats.messages.reverse();
        });
    },

    scrollToBottom () {
      const container = this.$refs.chatContainer;
      container.scrollTop = container.scrollHeight;
    },

    shouldShowDate (index) {
      if (index === 0) return true;
      const currentDate = new Date(this.mensagens[index].created_at).toDateString();
      const previousDate = new Date(this.mensagens[index - 1].created_at).toDateString();
      return currentDate !== previousDate;
    },
    formatDate (date) {
      moment.locale('pt-br');
      return moment(date).format('DD/MMMM/YYYY');
    },

    formatTimer (value) {
      moment.locale('pt-br');
      return moment(value).format('HH:mm');
    },

    adjustTextareaHeight () {
      const textarea = this.$refs.textarea;
      textarea.style.height = '50px';
      const newHeight = Math.min(textarea.scrollHeight, 200);
      textarea.style.height = `${newHeight}px`;
    },

    adjustTextareaHeights () {
      const textarea = this.$refs.textarea;
      textarea.style.height = '50px';
    }
  }
};
</script>
<style scoped>
.chat-header{
  background-color: #3c3d3b;
  color: white;
  padding: 5px;
  margin: 0 5px 5px 0;
  width: 500px;
}
.chat-text{
  width: 450px !important;
  border-radius: 0 0 0 0 !important;
  bottom:  0px !important;
  right: 50px !important;
  cursor: text !important;
  height: 47px;
}
.chat-text-send {
  border-radius: 0 0 0 0 !important;
  bottom:  0px !important;
  right: 0px !important;
  height: 47px;
}
.chat-box-msg-owner{
  background-color: #F1860B;
  color: white;
  border-radius: 10px;
  padding: 5px;
  margin: 5px;
  right: 0px;
  width: 100%;
  min-width: 65px !important;
  max-width: 225px !important;
}

.chat-box-msg-recived{
  background-color: #515050;
  color: white;
  border-radius: 10px;
  padding: 5px;
  margin: 5px;
  right: 0px;
  width: 225px;
}

.MensageChat {
    overflow: overlay;
    height: 540px;
}

.chat-icon {
    position: absolute;
    top: 97%;
    right: 65px;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 999;
}
@media screen and (max-width: 1366px) {
  .MensageChat {
    overflow: overlay;
    height: 445px;
}
}
</style>
<template>
    <div>
        <div class="d-flex justify-content-between align-items-center chat-header">
          <div v-if="this.user.type ===  'group'">
            <img src="../../../assets/img/group.png" style="width: 40px; height: 40px; border-radius: 50%;">
            <span class="font-docs ml-2" style="font-size:18px">{{ this.user.title }}</span>
          </div>
          <div v-if="this.user.type !==  'group'">
            <img :src="$userAvatar(ToSendUser?.path_image)" alt="Avatar" style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;">
            <span class="font-docs ml-2" style="font-size:18px">{{ ToSendUser.name }}</span>
          </div>
          <div>

          </div>
        </div>

    <div ref="chatContainer" class="MensageChat" style="padding: 1rem 1rem;">
        <div v-if="this.user.type === 'group'">
          <div v-for="(msg, index) in mensagens" :key="msg.id">
            <div v-if="shouldShowDate(index)" class="text-center my-2">
              <span class="font-docs text-muted" style="font-size: 16px;">{{ formatDate(msg.created_at) }}</span>
            </div>

            <div v-if="msg.user.uuid === Store.user.uuid">
                <div class="d-grid justify-content-end">
                  <span class="font-docs text-end mr-2" style="font-size:18px">{{ msg.user.name }}</span>
                    <div class="d-flex flex-column justify-content-end chat-box-msg-owner">
                      <span class="font-docs text-start">{{ msg.content }}</span>
                      <span class="font-docs text-muted text-end" style="font-size: 14px; color:#6e3d3d!important">{{ formatTimer(msg.created_at) }}</span>
                    </div>
                </div>
               </div>

               <div v-if="msg.user.uuid !== Store.user.uuid">
                <div class="d-grid justify-content-start">
                  <span class="font-docs text-start ml-2" style="font-size:18px">{{ msg.user.name }}</span>
                    <div class="d-flex flex-column justify-content-start chat-box-msg-recived">
                      <span class="font-docs text-start">{{ msg.content }}</span>
                    <span class="font-docs text-muted text-start" style="font-size: 14px; color:#c7c7c7!important">{{ formatTimer(msg.created_at) }}</span>
                    </div>
                </div>
               </div>
           </div>
          </div>

        <div v-if="this.user.type !==  'group'">
          <div v-for="(msg, index) in mensagens" :key="msg.id">
            <div v-if="shouldShowDate(index)" class="text-center my-2">
              <span class="font-docs text-muted" style="font-size: 16px;">{{ formatDate(msg.created_at) }}</span>
            </div>
              <div v-if="msg.user.uuid === Store.user.uuid" class="d-flex justify-content-end">
                <div v-if="msg.user.uuid === Store.user.uuid" class="d-flex justify-content-end">
                  <div class="d-flex flex-column justify-content-end chat-box-msg-owner">
                    <span class="font-docs text-start">{{ msg.content }}</span>
                    <span class="font-docs text-muted text-end" style="font-size: 14px; color:#6e3d3d!important">{{ formatTimer(msg.created_at) }}</span>
                  </div>
                </div>
               </div>
               <div v-if="msg.user.uuid !== Store.user.uuid" class="d-flex justify-content-start">
                  <div class="d-flex flex-column justify-content-start chat-box-msg-recived">
                    <span class="font-docs text-start">{{ msg.content }}</span>
                    <span class="font-docs text-muted text-start" style="font-size: 14px; color:#c7c7c7!important">{{ formatTimer(msg.created_at) }}</span>
                  </div>
               </div>
           </div>
          </div>
        </div>
        <div>
            <textarea class="fixed-plugin-button text-dark position-fixed chat-text"
            style="resize: none; overflow: hidden; max-height: 200px;"
            rows="2"
            @input="adjustTextareaHeight"
            @keydown.enter.exact.prevent="SendMensagem()"
            ref="textarea"
            v-model="mensagemToSend"
            ></textarea>
            <a @click="SendMensagem()"
                    class="px-3 py-2 fixed-plugin-button text-dark position-fixed background-Docs chat-text-send"
                >
                    <i v-if="!sending" class="fa fa-arrow-right" style="color: white;" aria-hidden="true"></i>
                    <i v-else class="fa fa-circle-o-notch fa-spin" style="color: white; font-size: 15px" aria-hidden="true"></i>
                    <span class="font-docs"></span>
            </a>
                <i
                  class="fa fa-paperclip chat-icon"
                  style="color: gray;"
                  aria-hidden="true"
              ></i>
        </div>
    </div>
</template>
